import { Component, input } from '@angular/core';

import { CoreService } from '../core.service';

import { NgClass, NgIf, NgFor, UpperCasePipe, DecimalPipe, TitleCasePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'


@Component({
	selector: 'app-channel',
	imports: [

		FormsModule, ReactiveFormsModule, NgIf

	],
	templateUrl: './channel.component.html',
	styleUrl: './channel.component.scss'
})
export class ChannelComponent {
	constructor( public core: CoreService ){ }
	info = input(null);


	ngOnInit(){

	}


}
